import httpInstance from '../httpInstance';

const getVersionsCommerceService = async () => {
  const endpoint = '/back-office/v1/commerce-version/all';
  const res = await httpInstance.get(endpoint);
  return res;
};

export default getVersionsCommerceService;
